export default function ArrowLeft({ variant = 'dark' }) {
  return (
    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.40889 10.6925C6.02641 11.0909 5.39338 11.1039 4.99497 10.7214L0.307468 6.22139C0.111038 6.03281 0 5.77229 0 5.5C0 5.2277 0.111038 4.96718 0.307468 4.77861L4.99497 0.278611C5.39338 -0.103864 6.02641 -0.0909443 6.40889 0.307467C6.79136 0.705878 6.77844 1.33891 6.38003 1.72139L3.48564 4.5L11 4.5C11.5523 4.5 12 4.94771 12 5.5C12 6.05228 11.5523 6.5 11 6.5L3.48564 6.5L6.38003 9.27861C6.77844 9.66109 6.79136 10.2941 6.40889 10.6925Z" fill="#20204D" fillOpacity={variant === 'light' ? 0.2 : 1.0} />
    </svg>
  )
}


